const initialState = {
  token: null,
  employeedata:null
};
// Either fix the reducer:
const authReducer = (state = initialState, action) => {
  console.log("Action received:", action);
  console.log("State before:", state);


  switch (action.type) {
    case "SET_REGTOKEN": // Updated from SET_TOKEN
      return {
        ...state,
        token: action.payload.token,
      };
    case "SET_EMPLOYEE_DATA":
      return {
        ...state,
        employeedata: action.payload.employeedata,
      };
    default:
      return state;
  }
};

export default authReducer;
